import { BaseViewStore} from 'core/stores';
import { action } from "mobx";

class FacilityOrderTemplatePNMissingInformationModalStore extends BaseViewStore {
    constructor(rootStore, componentProps) {
        const missingInformation = componentProps.modalParams.data.missingInformation;
        super(rootStore, {
            name: 'facility-order-template-pn-missing-information-modal',
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.missingInformation = missingInformation;
        this.generateMedicalNecessityForm = this.modalParams.data.generateMedicalNecessityForm;
    }

    @action.bound
    generate() {
        if(this.generateMedicalNecessityForm)
            this.generateMedicalNecessityForm();

        this.modalParams.close();
    }
}

export default FacilityOrderTemplatePNMissingInformationModalStore;
